import React, { useEffect, useState } from 'react'
import {getCategories} from '../services/CategoryService'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';


export default function CategoryMenu({setCategoryForBlogs}) {
  const [categories, setCategories] = useState([]);
  const [currentCategory, setCurrentCategory] = useState(0)

  const handleChange = (event) => {
    setCurrentCategory(event.target.categoryName)
  };

  const getBlogs = async (event, index) =>{
    console.log(event._id)
    setCurrentCategory(index)
    setCategoryForBlogs(event._id)
    // setCategories(categories)
  }

  useEffect(()=>{
    getCategories().then(res=>{
      console.log(res.data)
      getBlogs(res.data[0], 0)
      setCategories(res.data)
    }).catch(err => console.log(err))
  }, [])

  return (
    <div sx={{ maxWidth: '100%', bgcolor: 'background.paper'}}>
      <Tabs
        value={currentCategory}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >{ 
        categories && categories.map &&
        categories.map((category, index)=>(
          <Tab label={category.categoryName} key={category._id} onClick={()=>getBlogs(category, index)}/>
          ))
      }
      </Tabs>
    </div>
  );
}